import React, { useContext } from 'react';
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { AccessTokenContext } from '../../../common/context/AccessTokenProvider';

export const PersonalDataContext = React.createContext();

export const ACTIONS = {
    SET_LOAD_PAGE: "SET_LOAD_PAGE",  
    SET_ERROR:"SET_ERROR",
    SET_USER_ATTRIBUTES:"SET_USER_ATTRIBUTES",
    SET_JSON_FORM:"SET_JSON_FORM",
    SET_ALL_REGION:"SET_ALL_REGION",
    SET_ID_REGION:"SET_ID_REGION",
    SET_COMUNA_REGION:"SET_COMUNA_REGION",
    SET_JSON_FORMS: "SET_JSON_FORMS",
    SET_RESPONSE_POST_USER_ATTRIBUTES:"SET_RESPONSE_POST_USER_ATTRIBUTES"

};

const initialState = {
    loadPage: false,
    errorFetch: null,
    userAttributes:null,
    jsonForm: null,
    allRegion: null,
    idRegion: null,
    comunaRegion: null,
    responsePostUserAttributes: null,
};

const PersonalDataReducer = (state = initialState, action) => {

    switch (action.type){
        case ACTIONS.SET_LOAD_PAGE: {
            return {
                ...state,
                loadPage: action.payload
            };
        }
        case ACTIONS.SET_ERROR: {
            return {
                ...state,
                errorFetch: action.payload
            };
        }
        case ACTIONS.SET_JSON_FORMS: {
            return {
                ...state,
                jsonForm: action.payload
            };
        }
        case ACTIONS.SET_USER_ATTRIBUTES: {
            return {
                ...state,
                userAttributes: action.payload
            };
        }
        case ACTIONS.SET_RESPONSE_POST_USER_ATTRIBUTES: {
            return {
                ...state,
                responsePostUserAttributes: action.payload
            };
        }
        case ACTIONS.SET_ALL_REGION: {
            return {
                ...state,
                allRegion: action.payload
            };
        }
        case ACTIONS.SET_ID_REGION: {
            return {
                ...state,
                idRegion: action.payload
            };
        }   
        case ACTIONS.SET_COMUNA_REGION: {
            return {
                ...state,
                comunaRegion: action.payload
            };
        }
        default: {
            return state;
        }
    }

};

const PersonalDataContextProvider = ({children}) => {

    const { accessToken } = useContext(AccessTokenContext);

    const properties = React.useContext(ApplicationPropertiesContext);
    const [state, dispatch] = React.useReducer(PersonalDataReducer, initialState)

    React.useEffect(() => {
        LiferayService.getAllRegions(properties.base_url_api)
        .then((response) =>{
            dispatch({
                payload: response,
                type: ACTIONS.SET_ALL_REGION,
            });
            dispatch({
                payload: null,
                type: ACTIONS.SET_ERROR,
            });
            })
        .catch((error) => {
            dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
            });
        })
        
        if(accessToken) {
            LiferayService.getUserAttributes(properties.base_url_api)
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_USER_ATTRIBUTES,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
            })
            .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
            })
            dispatch({
                payload: null,
                type: ACTIONS.SET_ERROR,
            });
        }
 
    }, [accessToken])

    React.useEffect(() => {
        if(state.idRegion){
            LiferayService.getComunasFromRegion(properties.base_url_api, state.idRegion)
            .then((response) =>{
                dispatch({
                    payload: response,
                    type: ACTIONS.SET_COMUNA_REGION,
                });
                dispatch({
                    payload: null,
                    type: ACTIONS.SET_ERROR,
                });
            })
            .catch((error) => {
                dispatch({
                payload: error,
                type: ACTIONS.SET_ERROR,
                });
            })
        }
    }, [state.idRegion])

    React.useEffect(() => {
        if(accessToken && state.jsonForm){
            LiferayService.postUserAttributes(properties.base_url_api, state.jsonForm)
            .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_RESPONSE_POST_USER_ATTRIBUTES,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
            })
            .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
            })
        }

    }, [state.jsonForm, accessToken])

    return (
        <PersonalDataContext.Provider value={[state, dispatch]}>
            {children}
        </PersonalDataContext.Provider>

    )
}

export default PersonalDataContextProvider;